"use client";

import { useRef, useState, type ReactElement } from "react";
import { ENDPOINT_DESCRIPTIONS, type DashboardTestEndpoint } from "@/lib/test/constants";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";

export default function EndpointTooltip({ endpoint, children }: {
  endpoint: DashboardTestEndpoint;
  children: ReactElement;
}) {
  const [open, setOpen] = useState(false);
  const touchOpen = useRef(false);
  const close = () => { touchOpen.current = false; setOpen(false); };
  const [container, setContainer] = useState<HTMLSpanElement | null>(null);
  return <span className="contents" ref={setContainer}>
    <TooltipProvider>
      <Tooltip open={open} onOpenChange={(value) => {
        // Touch explanations stay open through the browser's focus/scroll adjustment.
        if (value || !touchOpen.current) setOpen(value);
      }}>
        <TooltipTrigger asChild onPointerDown={(event) => {
          touchOpen.current = event.pointerType === "touch";
        }} onBlur={close} onClick={(event) => {
          // Keep tap access without cancelling the endpoint button's own handler.
          event.preventDefault();
          setOpen(true);
        }}>
          {children}
        </TooltipTrigger>
        <TooltipContent container={container} collisionPadding={16} hideWhenDetached onEscapeKeyDown={close} onPointerDownOutside={close} className="max-w-[min(18rem,var(--radix-tooltip-content-available-width))]">
          {ENDPOINT_DESCRIPTIONS[endpoint]}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  </span>;
}
